import { Component, input } from '@angular/core';
import { WorkTicketUserChange } from '@work-frontend-monorepo/work-rest-api';
import { TranslateModule } from '@ngx-translate/core';
import { RouterLink } from '@angular/router';
import { AvatarComponent } from '../avatar/avatar.component';
import { FormatDatePipe } from '../../pipes/format-date.pipe';
import { PrependServerToFileSrcPipe } from '../../pipes/prepend-server-to-file-src.pipe';

@Component({
  selector: 'work-ui-timeline-ticket-user-change-item',
  templateUrl: './timeline-ticket-user-change-item.component.html',
  styleUrls: ['./timeline-ticket-user-change-item.component.scss'],
  standalone: true,
  imports: [RouterLink, TranslateModule, FormatDatePipe, AvatarComponent, PrependServerToFileSrcPipe],
})
export class TimelineTicketUserChangeItemComponent {
  ticketUserChange = input.required<WorkTicketUserChange>();
  tableStyle = input<boolean>(false);
}
